import OffersSpecialStore from './OffersSpecialStore'

export default OffersSpecialStore